import { configureStore } from '@reduxjs/toolkit';
import profileReducer, { profileInitialState } from './features/profile/profileSlice';
import cartReducer, { cartInitialState, Item } from './features/cart/cartSlice';
import catalogReducer from './features/catalog/catalogSlice';
import comboReducer, { comboInitialState } from './features/combo/comboSlice';
import { loadProfile, saveProfile, loadCart, saveCart, loadCombo, saveCombo } from './utils/sessionStorage';

const savedProfile = loadProfile();
const savedCart = loadCart();
const savedCombo = loadCombo();

const preloadedState = {
  profile: savedProfile
    ? { ...profileInitialState, ...savedProfile }
    : undefined,
  cart: savedCart
    ? { ...cartInitialState, items: savedCart.items as Item[], total: savedCart.total }
    : undefined,
  combo: savedCombo
    ? { ...comboInitialState, ...savedCombo }
    : undefined,
};

export const store = configureStore({
  reducer: {
    profile: profileReducer,
    cart: cartReducer,
    catalog: catalogReducer,
    combo: comboReducer,
  },
  preloadedState,
});

// Persist profile, cart and combo to sessionStorage whenever they change
store.subscribe(() => {
  const state = store.getState();
  saveProfile(state.profile as unknown as Record<string, unknown>);
  saveCart(state.cart);
  saveCombo(state.combo as unknown as Record<string, unknown>);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;